/** Em/en dashes only — do not match ASCII hyphens in compound words (trade-offs). */
const EM_DASH_BETWEEN_WORD_CHARS = /(\w)[\u2014\u2013—–](\w)/g;

/**
 * LLM narration rewrites sometimes glue words with em dashes (crew—er).
 * Normalize to spaced en dashes for speakable text and captions: crew – er.
 */
export function normalizeEmDashWordBoundaries(text: string): string {
	let result = text;
	let previous = "";
	while (result !== previous) {
		previous = result;
		result = result.replace(EM_DASH_BETWEEN_WORD_CHARS, "$1 \u2013 $2");
	}
	return result;
}
